import { useCallback } from 'react';

interface FormRootProps extends React.HTMLAttributes<HTMLFormElement> {}

export function FormRoot({
  className,
  children,
  onSubmit,
  ...props
}: FormRootProps) {
  const handleSubmit = useCallback(
    (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      e.stopPropagation();
      onSubmit?.(e);
    },
    [onSubmit],
  );

  return (
    <form className={className} onSubmit={handleSubmit} {...props}>
      {children}
    </form>
  );
}
